// ============================================================
// cart-scroll.js
// Scroll hint for cart drawer items section
// - Down arrow at bottom when scrollable
// - Up arrow at top when reached bottom
// - Hidden on empty cart or no overflow
// - Hidden when drawer is closed
// - Repositions correctly when footer expands/collapses
// ============================================================

(function() {
  var HINT_COLOR   = "#3d6b47";
  var SCROLLER_SEL = ".f-cart-drawer .f-drawer__scroller";
  var HINT_ID      = "cart-hint-items";

  // Inject CSS keyframe animations once
  (function() {
    if (document.getElementById("cart-hint-anim")) return;
    var s = document.createElement("style");
    s.id  = "cart-hint-anim";
    s.textContent = [
      "@keyframes chd1{0%,100%{opacity:0.15}20%{opacity:1}}",
      "@keyframes chd2{0%,100%{opacity:0.15}40%{opacity:1}}",
      "@keyframes chd3{0%,100%{opacity:0.15}60%{opacity:1}}",
      "@keyframes chu1{0%,100%{opacity:0.15}60%{opacity:1}}",
      "@keyframes chu2{0%,100%{opacity:0.15}40%{opacity:1}}",
      "@keyframes chu3{0%,100%{opacity:0.15}20%{opacity:1}}",
      ".ch-arr-d path:nth-child(1){animation:chd1 1.2s ease-in-out infinite}",
      ".ch-arr-d path:nth-child(2){animation:chd2 1.2s ease-in-out infinite}",
      ".ch-arr-d path:nth-child(3){animation:chd3 1.2s ease-in-out infinite}",
      ".ch-arr-u path:nth-child(1){animation:chu1 1.2s ease-in-out infinite}",
      ".ch-arr-u path:nth-child(2){animation:chu2 1.2s ease-in-out infinite}",
      ".ch-arr-u path:nth-child(3){animation:chu3 1.2s ease-in-out infinite}"
    ].join("");
    document.head.appendChild(s);
  })();

  var ICON_DOWN = '<svg class="ch-arr-d" width="14" height="16" viewBox="0 0 14 22" fill="none">'
    + '<path d="M1 1l6 6 6-6" stroke="' + HINT_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<path d="M1 8l6 6 6-6" stroke="' + HINT_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<path d="M1 15l6 6 6-6" stroke="' + HINT_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';
  var ICON_UP = '<svg class="ch-arr-u" width="14" height="16" viewBox="0 0 14 22" fill="none">'
    + '<path d="M1 21l6-6 6 6" stroke="' + HINT_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<path d="M1 14l6-6 6 6" stroke="' + HINT_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '<path d="M1 7l6-6 6 6" stroke="' + HINT_COLOR + '" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
    + '</svg>';
  var LABEL_DOWN = '<span style="font-size:12px;color:' + HINT_COLOR + ';font-family:sans-serif;">scroll down</span>';
  var LABEL_UP   = '<span style="font-size:12px;color:' + HINT_COLOR + ';font-family:sans-serif;">scroll up</span>';

  // -- Get or create hint element --
  function getHint() {
    var hint = document.getElementById(HINT_ID);
    if (!hint) {
      hint                      = document.createElement("div");
      hint.id                   = HINT_ID;
      hint.className            = "cart-scroll-hint";
      hint.style.position       = "fixed";
      hint.style.display        = "none";
      hint.style.alignItems     = "center";
      hint.style.justifyContent = "center";
      hint.style.gap            = "6px";
      hint.style.background     = "#ffffff";
      hint.style.borderRadius   = "20px";
      hint.style.padding        = "6px 14px";
      hint.style.fontSize       = "12px";
      hint.style.color          = HINT_COLOR;
      hint.style.fontFamily     = "sans-serif";
      hint.style.fontWeight     = "500";
      hint.style.whiteSpace     = "nowrap";
      hint.style.pointerEvents  = "none";
      hint.style.cursor         = "default";
      hint.style.zIndex         = "999999";
      hint.style.boxShadow      = "0 2px 8px rgba(0,0,0,0.15)";
      hint.style.opacity        = "0";
      hint.style.transition     = "opacity 0.3s ease";
      document.body.appendChild(hint);

      // Click: scroll to top when up arrow, scroll to bottom when down arrow
      hint.addEventListener("click", function() {
        var scroller = document.querySelector(SCROLLER_SEL);
        if (!scroller) return;
        var atBottom = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 15;
        if (atBottom) {
          scroller.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          scroller.scrollTo({ top: scroller.scrollHeight, behavior: "smooth" });
        }
      });
    }
    return hint;
  }

  // -- Show hint --
  function showHint(hint) {
    hint.style.display        = "flex";
    hint.style.opacity        = "0.75";
    hint.style.pointerEvents  = "auto";
    hint.style.cursor         = "pointer";
  }

  // -- Hide hint --
  function hideHint(hint) {
    hint.style.display        = "none";
    hint.style.opacity        = "0";
    hint.style.pointerEvents  = "none";
    hint.style.cursor         = "default";
  }

  // -- Lock scroller when overflowing so footer can't steal its height --
  // -- Remove lock when scroller has empty space so it can shrink naturally --
  function updateScrollerLock() {
    var scroller = document.querySelector(SCROLLER_SEL);
    if (!scroller) return;
    if (scroller.scrollHeight > scroller.clientHeight + 5) {
      scroller.classList.add("is-overflow");
    } else {
      scroller.classList.remove("is-overflow");
    }
  }

  // -- Check if drawer is currently open/visible --
  function isDrawerOpen() {
    // FoxTheme drawer component — check isOpen() if available
    if (window.FoxTheme && window.FoxTheme.CartDrawer && typeof window.FoxTheme.CartDrawer.isOpen === "function") {
      return window.FoxTheme.CartDrawer.isOpen();
    }

    // Fallback: check drawer element for open class/attribute
    var drawerEl = document.querySelector("#Drawer-Cart, drawer-component");
    if (drawerEl) {
      if (drawerEl.hasAttribute("open")) return true;
      if (drawerEl.classList.contains("is-open")) return true;
      if (drawerEl.classList.contains("drawer--open")) return true;
    }

    // Fallback: check drawer content visibility via bounding rect
    var drawerContent = document.querySelector("#Drawer-Cart .f-drawer__content");
    if (drawerContent) {
      var rect = drawerContent.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    }

    return false;
  }

  // -- Attach listeners to scroller --
  function updateHint() {
    var hint = getHint();
    updateScrollerLock();

    // Hide while Cart Drawer protection modal is open (drawer-only body class)
    if (document.body.classList.contains("modal-open")) {
      hideHint(hint);
      return;
    }

    // FIX 1: Always hide hint when drawer is closed
    if (!isDrawerOpen()) {
      hideHint(hint);
      return;
    }

    var scroller = document.querySelector(SCROLLER_SEL);

    // Hide if no scroller found
    if (!scroller) {
      hideHint(hint);
      return;
    }

    // Hide on empty cart
    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && cartDrawer.classList.contains("is-empty")) {
      hideHint(hint);
      return;
    }

    // Hide if drawer content not visible
    var drawerContent = document.querySelector("#Drawer-Cart .f-drawer__content");
    if (!drawerContent) {
      hideHint(hint);
      return;
    }
    var drawerRect = drawerContent.getBoundingClientRect();
    if (drawerRect.width === 0 || drawerRect.height === 0) {
      hideHint(hint);
      return;
    }

    var scrollTop    = scroller.scrollTop;
    var scrollHeight = scroller.scrollHeight;
    var clientHeight = scroller.clientHeight;
    var hasOverflow  = scrollHeight > clientHeight + 5;

    // Hide if no overflow
    if (!hasOverflow) {
      hideHint(hint);
      return;
    }

    var atBottom = scrollTop + clientHeight >= scrollHeight - 15;
    var rect     = scroller.getBoundingClientRect();
    var centerX  = rect.left + (rect.width / 2);

    // Get footer top to avoid overlapping it
    var footerEl  = document.querySelector(".f-cart-drawer .f-drawer__footer");
    var footerTop = footerEl ? footerEl.getBoundingClientRect().top : window.innerHeight;

    // Clamp bottom position strictly above footer
    var visibleBottom = footerTop - 44;
    var visibleTop    = Math.max(rect.top, 0) + 10;

    if (atBottom) {
      hint.innerHTML       = ICON_UP + LABEL_UP;
      hint.style.top       = visibleTop + "px";
      hint.style.left      = centerX + "px";
      hint.style.transform = "translateX(-50%)";
    } else {
      hint.innerHTML       = ICON_DOWN + LABEL_DOWN;
      hint.style.top       = visibleBottom + "px";
      hint.style.left      = centerX + "px";
      hint.style.transform = "translateX(-50%)";
    }

    showHint(hint);
  }

  // -- Attach listeners to scroller --
  function attachListener() {
    var scroller = document.querySelector(SCROLLER_SEL);

    if (!scroller) return;

    if (scroller._scrollHintAttached) {
      updateHint();
      return;
    }

    scroller._scrollHintAttached = true;
    updateScrollerLock();

    // Scroll event
    scroller.addEventListener("scroll", updateHint);

    // Watch items added/removed
    new MutationObserver(function() {
      setTimeout(updateHint, 200);
    }).observe(scroller, { childList: true, subtree: true });

    // Watch is-empty class on cart-drawer
    var cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      new MutationObserver(function() {
        setTimeout(updateHint, 100);
      }).observe(cartDrawer, { attributes: true, attributeFilter: ["class"] });
    }

    // Watch drawer element for open/close class or attribute changes
    var drawerEl = document.querySelector("#Drawer-Cart, drawer-component");
    if (drawerEl) {
      new MutationObserver(function() {
        setTimeout(updateHint, 100);
      }).observe(drawerEl, { attributes: true, attributeFilter: ["style", "class", "open"] });
    }

    // Watch drawer content visibility
    var drawerContent = document.querySelector("#Drawer-Cart .f-drawer__content");
    if (drawerContent) {
      new MutationObserver(function() {
        setTimeout(updateHint, 100);
      }).observe(drawerContent, { attributes: true, attributeFilter: ["style", "class"] });
    }

    // Reposition hint when footer expands/collapses
    var footer = document.querySelector(".f-cart-drawer .f-drawer__footer");
    if (footer) {
      new MutationObserver(function() {
        setTimeout(updateHint, 350);
      }).observe(footer, { subtree: true, attributes: true, childList: true, attributeFilter: ["style", "class"] });
    }

    updateHint();
  }

  // -- Init --
  function init() {
    attachListener();
    updateHint();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  }

  // Init on page load
  setTimeout(init, 1000);

  // Re-init on cart refresh
  document.addEventListener("cart:refresh", function() {
    setTimeout(init, 600);
  });

  // FIX 1: Hide hint on known drawer-close events
  document.addEventListener("cart:close", function() {
    hideHint(getHint());
  });
  document.addEventListener("drawer:close", function() {
    hideHint(getHint());
  });

  // Re-run when cart icon clicked (open)
  document.addEventListener("click", function(e) {
    if (
      e.target.closest("[data-drawer-trigger]") ||
      e.target.closest(".cart-link")            ||
      e.target.closest("[data-open-cart]")       ||
      e.target.closest(".f-cart-btn")            ||
      e.target.closest("[data-drawer-open]")
    ) {
      setTimeout(updateHint, 600);
    }

    // FIX 1: Hide hint when close button is clicked
    if (
      e.target.closest(".f-drawer__close")       ||
      e.target.closest("[data-drawer-close]")    ||
      e.target.closest(".drawer__close")         ||
      e.target.closest("[data-close-drawer]")
    ) {
      hideHint(getHint());
    }

    // FIX 1: Hide when clicking overlay/backdrop
    if (
      e.target.closest(".drawer-overlay")  ||
      e.target.closest(".modal-overlay")   ||
      e.target.classList && e.target.classList.contains("drawer-overlay")
    ) {
      hideHint(getHint());
    }
  });

  // Update on resize
  window.addEventListener("resize", updateHint);

  window.FoxThemeCartScroll = {
    hideHint: function() {
      hideHint(getHint());
    },
    updateHint: updateHint
  };

})();